/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */
import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';

const BuildingSlice = createSlice({
    name: 'buildingSection',
    initialState: {
        getAllBuildings: [],
        createBuilding: {},
        updateBuilding: {},
        getPublicBuildingById: null,
        // Resident of the external registration, kept between the identify you step
        // and the success screen
        buildingRegistrationResident: null,
        createResidentWhiteList: {},
        // Summary of the last white list creation, read by the import errors view
        whiteListImportResult: null,
        // Template uploaded on the automatic tab, the import errors view reads the
        // sheet back so the grid keeps the columns and the rows of the excel
        whiteListImportFile: null,
    },
    reducers: {
        /**
         * Keeps the summary returned by the create all endpoint so the import
         * errors view can paint the failed rows after the navigation.
         */
        setWhiteListImportResult: (state, action) => {
            state.whiteListImportResult = action.payload;
        },
        /**
         * Keeps the file of the automatic tab so the import errors view can read
         * the rows the failures point at. It stays null when the white list was
         * only captured by hand.
         */
        setWhiteListImportFile: (state, action) => {
            state.whiteListImportFile = action.payload;
        },
        /**
         * Keeps the resident of the external registration between the identify you
         * step and the success screen, the summary is painted with the data the
         * owner registered and the service validated.
         */
        setBuildingRegistrationResident: (state, action) => {
            state.buildingRegistrationResident = action.payload;
        },
    },
    extraReducers: {
        'buildingSection/getAllBuildings/fulfilled': (state, action) => {
            state.getAllBuildings = ResponseApi(action.payload);
        },
        'buildingSection/createBuilding/fulfilled': (state, action) => {
            state.createBuilding = ResponseApi(action.payload);
        },
        'buildingSection/updateBuilding/fulfilled': (state, action) => {
            state.updateBuilding = ResponseApi(action.payload);
        },
        'buildingSection/getPublicBuildingById/fulfilled': (state, action) => {
            state.getPublicBuildingById = ResponseApi(action.payload);
        },
        'buildingSection/createResidentWhiteList/fulfilled': (state, action) => {
            state.createResidentWhiteList = ResponseApi(action.payload);
        },
    },
});

export const { setWhiteListImportResult, setWhiteListImportFile, setBuildingRegistrationResident } = BuildingSlice.actions;

export default BuildingSlice.reducer;
